import { Panels, ListNav2, Breadcrumb } from 'peach/components'
import { getName } from 'peach/helpers'
import { Switch, Redirect, Route, useRouteMatch, useParams } from 'peach/router'

import { useLoanDrawGet } from 'core/types'

import DrawBalances from './DrawBalances'
import DrawPurchase from './DrawPurchase'
import DrawPurchases from './DrawPurchases'
import DrawRates from './DrawRates'
import LoanDraw from './LoanDraw'

const items = [['Draw', '', true], '/balances', '/purchases', '/rates']

const LoanDrawRoutes = () => {
  const { path, url } = useRouteMatch()

  const { companyId, personId, loanId, drawId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    drawId?: string
  }>()

  const { data: draw } = useLoanDrawGet({
    personId,
    loanId,
    drawId,
    options: { enabled: !!(companyId && personId && loanId && drawId) },
  })

  const nav = <ListNav2 baseUrl={url} items={items} />

  return (
    <Panels left={nav}>
      <Breadcrumb title={getName(draw)} />
      <Switch>
        <Route exact path={`${path}`}>
          <LoanDraw />
        </Route>
        <Route crumb path={`${path}/balances`}>
          <DrawBalances />
        </Route>
        <Route crumb path={`${path}/rates`}>
          <DrawRates />
        </Route>
        <Route crumb path={`${path}/purchases`}>
          <Switch>
            <Route path={`${path}/purchases/:purchaseId`}>
              <DrawPurchase />
            </Route>
            <Route>
              <DrawPurchases />
            </Route>
          </Switch>
        </Route>
        <Redirect to={url} />
      </Switch>
    </Panels>
  )
}

export default LoanDrawRoutes
